// extracted by mini-css-extract-plugin
module.exports = {"container":"Spinner_container__KU0xk","spin":"Spinner_spin__1UdxE"};